import { localStore } from "@/core/store"
import logger from "@/core/logger"
import settings from "@/core/settings"
import api from "./api"
import { PushedProduct } from "@/types"
import { Cart } from "@/core/tagging/types"

interface CartUpdate {
  added_items: PushedProduct[]
  cart: Cart
}

const storeKey = "nosto:itemsAddedToCart"

function waitForCartUpdateInStore() {
  let breakLoop = false
  window.addEventListener("beforeunload", () => {
    breakLoop = true
  })

  let timesWaitForFocus = 0
  let intervalId = 0
  const checkInterval = 200
  const checkStore = () => {
    if (breakLoop) {
      if (intervalId) {
        window.clearInterval(intervalId)
      }
      return
    }

    // Do not show if current browser tab is not active. It is supported by newer browsers.
    // It still shows if there are 2 browser windows open and both of them are visible on the screen
    if (document.hidden === true) {
      return
    }

    const cartUpdate = localStore.getAsJson<CartUpdate>(storeKey)
    if (cartUpdate) {
      // If it is not onFocus, but it is not document.hidden, it could be in the other browser window.
      // Wait max 3 seconds if it is still not been shown, then just show the popup here
      if (timesWaitForFocus < 3000 / checkInterval && document.hasFocus && !document.hasFocus()) {
        timesWaitForFocus += 1
        logger.debug("Not on focus, skip showing add to cart popup on this page.")
      } else {
        timesWaitForFocus = 0

        localStore.remove(storeKey)

        void api.loadCartPopupRecommendations(cartUpdate.added_items, cartUpdate.cart, true)
      }
    } else {
      timesWaitForFocus = 0
    }
  }

  checkStore()
  intervalId = window.setInterval(checkStore, checkInterval)
}

export function watchAddToCartEvent() {
  if (settings.addToCartPopup !== true) {
    logger.debug("Add to cart popup feature is disabled, skip subscribing message channel")
    return
  }

  if (settings.triggerAddToCartPopupWithCookie) {
    waitForCartUpdateInStore()
  }
}
